import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import API from '../../API';

/**
 * Display to show / select Demographic categories (i.e. senior citizen, etc.) for a user
 * @param {*} props 
 * @author BrianCastor
 */
export default function DemographicsSelector(props) {
  const field = 'Demographics_MPL__c';
  const [selectedDemographics, setSelectedDemographics] = React.useState(props.userData[field] || []);
  const demographicOptions = API.getAllDemographicCategories();

  React.useEffect(() => {
    let newData = {}
    newData[field] = selectedDemographics;
    props.updateUserData(newData);
  }, [])

  function handleToggle(demographicName) {
    let temp = [...selectedDemographics];
    if (temp.includes(demographicName)) {
      temp.splice(temp.indexOf(demographicName), 1)
      setSelectedDemographics(temp);
    }
    else {
      temp.push(demographicName);
      setSelectedDemographics(temp);
    }
    let newData = {}
    newData[field] = temp;
    props.updateUserData(newData);
  }

  return (
    <div>
      <h3>What communities are you a part of?</h3>
      <div style={{ textAlign: 'left' }}>
        {demographicOptions.map((demographicName, index) => (
          <div key={index}>
            <FormControlLabel
              control={
                <Switch
                  checked={selectedDemographics.includes(demographicName)}
                  onChange={() => handleToggle(demographicName)}
                  name={demographicName}
                  color="primary"
                />
              }
              key={index}
              label={demographicName}
            />
            <br /></div>))}
      </div>
    </div>
  );
}